<template>
  <v-app-bar app flat :color="this.$vuetify.theme.dark ? 'secondary' : 'white'" hide-on-scroll class="align-center d-print-none" :height="this.$vuetify.breakpoint.xs ? '128' : '192'">
    <v-container class="d-flex align-center container--max ch-toolbar px-0">
      <v-app-bar-nav-icon @click.stop="updateDrawer(!! $event)" aria-label="Navigation Menu"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <a href="/" role="button" aria-label="Home">
        <v-img
          :src="logo" 
          :width="logoWidth"
          :aspect-ratio="596/137"
          contain 
          class="mb-2"
          :class="this.$vuetify.breakpoint.xs ? '' : 'mr-8'"
        ></v-img>
        <!-- :aspect-ratio="596/137" -->
        <!-- :height="this.$vuetify.breakpoint.xs ? 56 : 72" 
        :width="this.$vuetify.breakpoint.xs ? 240 : 596" -->
      </a>
      <v-spacer></v-spacer>
      <v-btn icon aria-label="Search" @click.stop="openSearch">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </v-container>
    <template v-slot:extension>
      <v-tabs hide-slider show-arrows slider-color="accent" class="primary tabs--max" dark>
        <v-tab class="v-tab--icon" href="/"><v-icon>mdi-home</v-icon></v-tab>
        <v-tab
          v-for="(item, i) in menuItems"
          :aria-label="item.title"
          :key="'p'+i"
          :href="item.url"
          v-html="item.title"
          class="white--text d-none d-md-flex"
        ></v-tab>
<!--         <v-tab class="white--text d-none d-md-flex">Tory Diary</v-tab>
        <v-tab class="white--text d-none d-md-flex">Columnists</v-tab>
        <v-tab class="white--text d-none d-md-flex">Comment</v-tab>
        <v-tab class="white--text d-none d-md-flex">MPs</v-tab>
        <v-tab class="white--text d-none d-md-flex">Local Gov</v-tab>
        <v-tab class="white--text d-none d-md-flex">Culture</v-tab> -->
        <v-spacer></v-spacer>
        <v-tab class="v-tab--icon accent white--text" href="/daily-email" aria-label="Email Signup">
          <!-- <v-icon color="white" left class="d-block d-sm-none d-md-block">mdi-email-edit-outline</v-icon> -->
          <!-- <span class="d-none d-sm-block d-md-none d-lg-block">Get our&nbsp;</span> -->
          <span>Get our free Daily Email</span>
          <!-- <v-icon color="white">mdi-email-edit-outline</v-icon> -->
        </v-tab>
        <!-- <v-tab class="v-tab--icon accent" href="/audio" aria-label="Audio"><v-icon color="white">mdi-podcast</v-icon></v-tab>
        <v-tab class="v-tab--icon accent" href="/video" aria-label="Video"><v-icon color="white">mdi-play-circle-outline</v-icon></v-tab> -->
<!--         <v-tab class="v-tab--icon blue accent-2 white--text" href="https://www.facebook.com/ConservativeHome/" target="_blank" rel="noopener">
          <v-icon color="white">mdi-facebook</v-icon>
        </v-tab>
        <v-tab class="v-tab--icon light-blue accent-3 white--text" href="https://twitter.com/conhome" target="_blank" rel="noopener">
          <v-icon color="white">mdi-twitter</v-icon>
        </v-tab> -->
      </v-tabs>
    </template>

    <!-- search -->
    <v-dialog
      eager
      v-model="dialog"
      max-width="290"
      fullscreen hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card tile>
        <v-toolbar flat color="transparent">
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container fill-height style="height: calc( 100vh - 64px )">
          <v-row align="center" justify="center">
            <v-col cols="11" sm="10" md="9" lg="8" class="text-center pb-12">
              <v-text-field color="accent" autofocus ref="searchfield" v-model="search" label="Search" append-icon="mdi-magnify" @click:append="submitSearch" @keydown.enter="submitSearch" clearable></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

  </v-app-bar>
</template>

<script>
  export default {
    name: 'NavToolbar',

    props: {
      drawer: {
        type: Boolean,
        default: false
      },
      menuItems: {
        type: Array,
        default: () => ([])
      }
    },

    data: () => ({
      dialog: false,
      finalLogo: require('@/assets/conhome-logo-new-final.svg'),
      pinkLogo: require('@/assets/conhome-full-logo-pink.svg'),
      fullLogo: require('@/assets/conhome-full-logo-fixed.svg'),
      houseLogo: require('@/assets/conhome-house-logo-fixed.svg'),
      search: '',
      widths: {
        xs: 208, //244,
        sm: 340, //360,
        md: 360, //390,
        lg: 420,
        xl: 420
      }
    }),

    computed: {
      logo() {
        return this.finalLogo //this.$vuetify.breakpoint.xs ? this.houseLogo : this.fulllogo
      },
      logoSize() {
        return {
          width: 596,
          height: 137
        }
      },
      logoHeight() {
        return 56
        // return this.$vuetify.breakpoint.xs
        //   ? 56
        //   : this.$vuetify.breakpoint.md
        //     ? 72
        //     : 96
      },
      logoWidth() {
        return this.widths[this.$vuetify.breakpoint.name]
        // return this.$vuetify.breakpoint.xs
        //   ? 240
        //   : this.$vuetify.breakpoint.md
        //     ? 310
        //     : 596
      }
    },

    methods: {
      openSearch() {
        this.dialog = true
        // this.$refs.searchField.$el.focus()
        let self = this
        setTimeout(function() {self.$nextTick(self.$refs.searchfield.focus)}, 200)
      },
      submitSearch() {
        window.location.href = '/?s=' + this.search
      },
      updateDrawer(state) {
        this.$emit('updated', state)
      },
    }
  }
</script>
